import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { loginWithSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId }});
        loginWithSession(data.user);
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Selamat datang, ${data.user.name}`);
        if (data.user.role === "pending") {
          nav("/", { state: { user: data.user }, replace: true });
        } else {
          nav("/dashboard", { state: { user: data.user }, replace: true });
        }
      } catch (e) {
        toast.error("Gagal memproses login Google");
        nav("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen app-bg flex items-center justify-center">
      <div className="text-center">
        <div className="w-14 h-14 rounded-lg bg-brand text-white flex items-center justify-center mx-auto mb-4">
          <Sparkles className="w-7 h-7 animate-pulse"/>
        </div>
        <div className="font-display font-semibold">Menyelesaikan login Google...</div>
        <div className="text-xs text-[#8C9096] mt-1">Mohon tunggu.</div>
      </div>
    </div>
  );
}
